// import axios from "axios";
// import Cookies from "js-cookie";

// const instance = axios.create({
//   baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
//   timeout: 50000,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// });

// instance.interceptors.request.use(function (config) {

//   let adminInfo;
//   if (localStorage.getItem("adminInfo")) {
//     adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
//   }

//   let company;

//   if (Cookies.get("company")) {
//     company = Cookies.get("company");
//   }

//   return {
//     ...config,
//     headers: {
//       authorization: adminInfo ? `Bearer ${adminInfo.token}` : null,
//       company: company ? company : null,
//     },
//   };
// });

// const responseBody = (response) => response.data;

// const requests = {
//   get: (url, body, headers) =>
//     instance.get(url, body, headers).then(responseBody),

//   post: (url, body) => instance.post(url, body).then(responseBody),

//   put: (url, body, headers) =>
//     instance.put(url, body, headers).then(responseBody),

//   patch: (url, body) => instance.patch(url, body).then(responseBody),

//   delete: (url, body) => instance.delete(url, body).then(responseBody),
// };

// export default requests;



import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 50000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  function (config) {
    let adminInfo;

    if (localStorage.getItem("adminInfo")) {
      adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
    }

    let company;

    if (Cookies.get("company")) {
      company = Cookies.get("company");
    }

    return {
      ...config,
      headers: {
        ...config.headers,
        authorization: adminInfo ? `Bearer ${adminInfo.token}` : null,
        company: company ? company : null,
      },
    };
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      localStorage.removeItem("adminInfo");
      localStorage.removeItem("chatId");
      localStorage.removeItem("agentId");
      localStorage.removeItem("stateId");
      localStorage.removeItem("receiverName");
      localStorage.removeItem("agentNameFChat");

      sessionStorage.removeItem("isOnline");

      Cookies.remove("company");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

const responseBody = (response) => response.data;

const requests = {
  get: (url, body, headers) =>
    instance.get(url, body, headers).then(responseBody),

  post: (url, body) =>
    instance.post(url, body).then(responseBody),

  put: (url, body, headers) =>
    instance.put(url, body, headers).then(responseBody),

  patch: (url, body) =>
    instance.patch(url, body).then(responseBody),

  delete: (url, body) =>
    instance.delete(url, body).then(responseBody),
};

export default requests;